import React, { useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Grid, TextField } from '@mui/material'
import { Box } from '@mui/system'
import DetailIDSwitch from '../../Components/DetailIDSwitch'
import { useGlobalContext } from '../../Contexts/GlobalTriggers'
import VesselInfoSection from './VesselInfoSection'
import AddConfirmDialog from './Dialogs/AddConfirmDialog'
import VesselCards from './VesselCards'
import {
  useVesselContext,
  VesselViewFields,
} from '../../Contexts/Modules/SampleModule/VesselModule'
import VesselHoldingSection from './VesselHoldingSection'
import { delay } from '../../Functions/DelayFn'
import { useVesselMove } from '../../APIs/Hooks/VesselHooks'

function VesselView() {
  const { pathname } = useLocation()
  const { vesselQuery } = useVesselContext()
  const [moveData, setMoveData] = useState(undefined)
  const { playScanSound } = useGlobalContext()
  const { setFields, fields } = useVesselContext()
  const [detailsActive, setDetailsActive] = useState(true)
  const vesselRef = useRef<HTMLHeadingElement>(null)
  const holdingView = pathname.includes('holding')

  const { mutate: moveVessel } = useVesselMove(
    vesselQuery?.data?.VesselID,
    setMoveData,
  )

  return (
    <Box
      sx={{
        maxWidth: 'md',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box sx={{ width: 1 }}>
        {holdingView ?
          <VesselHoldingSection />
        : <VesselInfoSection />}
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: 1 }}>
          <Box sx={{ flex: 1 }}>
            <DetailIDSwitch
              detailOn={detailsActive}
              setDetailOn={setDetailsActive}
            />
          </Box>
          <Box sx={{ display: 'flex', flex: 1 }}>
            <TextField
              id="vesselID"
              value={fields?.vesselID || ''}
              autoFocus
              margin="normal"
              helperText={
                holdingView ?
                  'Enter vessel ID which you want to add to this holding'
                : 'Enter sample ID which you want to add to this vessel'
              }
              fullWidth
              ref={vesselRef}
              onChange={(e: any) =>
                setFields((fields: VesselViewFields) => ({
                  ...fields,
                  vesselID: e.target.value,
                }))
              }
              onKeyDown={(e: any) => {
                if (
                  (e.code === 'Enter' || e.code === 'Tab') &&
                  e.target.value
                ) {
                  playScanSound(true)
                  delay(500).then(() =>
                    moveVessel({ move_vessel: e.target.value }),
                  )
                }
              }}
            />
          </Box>
        </Box>
        <Grid
          container
          spacing={2}
        >
          <VesselCards
            vessels={vesselQuery.data?.Vessels}
            samples={vesselQuery.data?.Samples}
            holdingView={holdingView}
            detailsActive={detailsActive}
          />
        </Grid>
      </Box>
      <AddConfirmDialog
        moveData={moveData}
        setMoveData={setMoveData}
        holdingView={holdingView}
      />
    </Box>
  )
}

export default VesselView
